var lib_core = require("lib-core");
var editor_3d = require("editor-3d-light");
var ui_extensions = require("ui-extensions");
var cio_datamodel = require("cio-datamodel");
var THREE           = require("three");
var lib_geometry = require("lib-geometry")
var cio_config = require("cio-config");

var TabController = require("ui-extensions").TabController;
var ProcessingController = require("ui-extensions").ProcessMessageController;
var ErrorMessageController  = require("ui-extensions").ErrorMessageController;

var PackageViewerModel = require("./packageFootprintViewerModel.js");
var PackageViewerStateMachine = require("./packageStateMachine.js");
var PackageViewerView = require("./packageFootprintViewerView.js");
//var BoardController = require("./../boardViewer/packageBoardController");
var PackageMasterController = require("../packageMasterView/packageMasterController.js");

var UserSettingsController = require("../../../shared/extensions/userSettings/userSettingsController.js");

var PackageFootprintViewerController = function(archLayers, dependencies, configuration) {
    this.config = configuration;
    editor_3d.Abstract3dViewerController.call(this, archLayers, dependencies, configuration);

    this.cameraButtons = configuration.cameraButtons;
    this.placementButtons = configuration.placementButtons;

    lib_core.GuiEvents.addEvents({
        // these top two are no longer used because datamodel loads synchronusly
        MODEL_LOAD_START:              {id: 'package_model_01', name: "MODEL_LOAD_START" } ,
        MODEL_LOAD_COMPLETE:           {id: 'package_model_02', name: "MODEL_LOAD_COMPLETE" } ,
        ///
        MODEL_MAKE_BOX:                {id: 'package_model_03', name: "MODEL_MAKE_BOX" } ,
        MODEL_PLACE_DOWN:              {id: 'package_model_04', name: "MODEL_PLACE_DOWN" },
        MODEL_PLACE_CENTER:            {id: 'package_model_05', name: "MODEL_PLACE_CENTER" },
        MODEL_RESET_VIEW:              {id: 'package_model_06', name: "MODEL_RESET_VIEW" },
        MODEL_CLONE_POSITION:          {id: 'package_model_07', name: "MODEL_CLONE_POSITION" },
        MODEL_REMOVE:                  {id: 'package_model_08', name: "MODEL_REMOVE" },
        MODEL_BOARD_EXPORT_FOOTPRINT:        {id: 'package_model_09', name: "MODEL_BOARD_EXPORT_FOOTPRINT" },
        
        CLOSE_XREF_OBJ_MODAL:                   {id: 'package_model_10', name: "CLOSE_XREF_OBJ_MODAL" },
        CLOSE_EMPTY_OBJ_MODAL:                  {id: 'package_model_11', name: "CLOSE_EMPTY_OBJ_MODAL" },
        CLOSE_FUSION_LINKED_MODAL:              {id: 'package_model_12', name: "CLOSE_FUSION_LINKED_MODAL" },
        CLOSE_EMPTY_OBJ_LINKED_MODAL:           {id: 'package_model_13', name: "CLOSE_EMPTY_OBJ_LINKED_MODAL" },
    });
};

lib_core.inherit(PackageFootprintViewerController, editor_3d.Abstract3dViewerController);
PackageFootprintViewerController.inject = lib_core.clone(editor_3d.Abstract3dViewerController.inject);
PackageFootprintViewerController.inject.switcherController = ui_extensions.SwitcherController;
PackageFootprintViewerController.inject.cameraController = editor_3d.Camera3dController;
PackageFootprintViewerController.inject.tabController = TabController;
PackageFootprintViewerController.inject.processingController = ProcessingController;
PackageFootprintViewerController.inject.selectionController = editor_3d.Selection3dController;
PackageFootprintViewerController.inject.errorController = ErrorMessageController;
PackageFootprintViewerController.inject.optionsController = ui_extensions.OptionsController;
PackageFootprintViewerController.inject.masterController = PackageMasterController;
PackageFootprintViewerController.inject.userSettingsController = UserSettingsController;

module.exports = PackageFootprintViewerController;

PackageFootprintViewerController.prototype.beforeLoad = function() {
    if(this.cameraButtons){
        this.tabController.getView().registerButton({
            name: "Reset Camera View",
            title: "Reset Camera View",
            sortOrder: 1,
            eventType: lib_core.GuiEvents.MODEL_RESET_VIEW,
            style: {
                icon: "icon-zoom-extents.svg",
            },
            group: "camera"
        });
    }

    if (this.tabController && this.placementButtons){

        this.placeOnBoardButton = this.tabController.getView().registerButton({
            name: 'Place On Board',
            title: 'Place On Board',
            sortOrder: 2,
            eventType: lib_core.GuiEvents.MODEL_PLACE_DOWN,
            style: {
                icon: 'icon-place-down.svg',
            },
            group: "modifier"
        });

        this.placeAtCenterButton = this.tabController.getView().registerButton({
            name: 'Place On Center',
            title: 'Place On Center',
            sortOrder: 3,
            eventType: lib_core.GuiEvents.MODEL_PLACE_CENTER,
            style: {
                icon: 'icon-align-origin.svg',
            },
            group: "modifier"
        });

        // this.tabController.getView().registerButton({
        //     name: 'Set All Positions',
        //     title: 'Set All Positions',
        //     sortOrder: 4,
        //     eventType: lib_core.GuiEvents.MODEL_CLONE_POSITION,
        //     style: {
        //         icon: 'icon-duplicate.svg',
        //     },
        //     group: "modifier"
        // });

    }

    lib_core.Controller.prototype.beforeLoad.call(this);
};

PackageFootprintViewerController.prototype.createModel = function () {
    // package viewer model will listen to changes and swap out IM/View pairs
    return new PackageViewerModel(this.root.data, this.switcherController.getModel(), this.editorController.getModel(),
        null, this.selectionController.getModel(), this.cameraController.getModel(), this.processingController.getModel(),
        this.errorController.getModel(), this.masterController.getModel(), this.userSettingsController.getModel(),
        this.editorController.getView(), this.configuration);
};

PackageFootprintViewerController.prototype.createStateMachine = function () {
    return new PackageViewerStateMachine(this.root, this.getModel());
};


PackageFootprintViewerController.prototype.createView = function(){
    // Just define view here for now (TODO move it)
   var config = this.configuration;
   var scale = this.editorController.getModel().config.scale;
   var camera = this.cameraController.getModel();

    return new PackageViewerView(this.root, this.getModel(), this.editorController.getView(), this.getStatemachine(), config, scale, camera, this.masterController.getView(), this.placeOnBoardButton, this.placeAtCenterButton);
}

PackageFootprintViewerController.prototype.afterBuild = function() {
    var self = this;

    var modelCentroidConfig = {
        label       : 'Use Model Centroid',
        type        : ui_extensions.InspectorInputType.CHECKBOX,
        datamember  : this.getModel().modelCenterOrigin,
        visible     : this.root.data.model3d
    };

    var footprintCentroidConfig = {
        label       : 'Use Footprint Centroid',
        type        : ui_extensions.InspectorInputType.CHECKBOX,
        datamember  : this.getModel().footprintCenterOrigin
    };

    if(this.optionsController) {
       var elements = [];

        if(this.placementButtons && !this.masterController.getModel().wizardMode()){
            elements = elements.concat([modelCentroidConfig, footprintCentroidConfig]);
        }

        if (!this.editorController.getView().usingCanvas) {
             elements.push({
                label         : 'Package Transparency',
                type          : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember    : this.getModel().packageTransparency,
                datatype      : cio_config.types.positive_float,
                unit          : "%"
            });

            elements.push({
                label       : 'Show 3D Model',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.getModel().show3dModel
            });

            elements.push({
                label       : 'Show Footprint',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.getModel().showFootprint
            });

            elements.push({
                label       : 'Show Grid',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.getModel().showGrid
            });

            elements.push({
                label       : 'Show Board',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.getModel().showBoard
            });
        };

        this.optionsController.addOptionGroup(elements);

        this.masterController.getModel().wizardMode.onChange(this, function(val) {
            if(!val && self.placementButtons) {
                var options = self.optionsController.getModel().options;
                options.add(0, modelCentroidConfig);
                options.add(0, footprintCentroidConfig);
            }
        });
    }

    if (!this.editorController.getView().usingCanvas) {
        this.getModel().showBoard(true);
        this.getModel().showFootprint(true);
        this.getModel().showGrid(true);
        this.getModel().show3dModel(true);
    } else {
        this.getModel().showBoard(false);
    }

    if(this.root.data.model3d() instanceof cio_datamodel.BoxData && !this.root.data.hasIPCPreview()){
        this.getModel().packageTransparency(90);
    } else {
        this.getModel().packageTransparency(100);
    }
}
